<template>
  <b-modal ref="addFAQModal"
           id="modal-add-faq"
           title="Добавить ответ на вопрос"
           hide-footer>
      <b-form @submit="onSubmit" @reset="onReset" class="w-100">
      <alertMsg :message="alertMessage" v-if="showAlert"></alertMsg>
      <b-form-group id="form-title-group-question">
        <b-form-textarea id="question"
                        type="text"
                        placeholder="Введите вопрос"
                        v-model="addForm.question"
                        required>

        </b-form-textarea>
      </b-form-group>
      <b-form-group id="form-title-group-answer">
        <b-form-textarea id="answer"
                        type="text"
                        placeholder="Введите ответ"
                        v-model="addForm.answer"
                        required>

        </b-form-textarea>
      </b-form-group>
      <b-form-group id="form-title-group-tags">
        <b-form-input id="tags"
                        type="text"
                        placeholder="Введите тэги (через пробел)"
                        v-model="addForm.tags"
                        >

        </b-form-input>
      </b-form-group>
      <b-button type="submit" variant="success">Добавить</b-button>
      <b-button type="reset" variant="">Отмена</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import alertMsg from '../common/AlertMsg';

export default {
  components: {
    alertMsg,
  },
  name: 'modalAdd',
  data() {
    return {
      addForm: {
        question: '',
        answer: '',
        tags: '',
      },
      alertMessage: 'Error',
      showAlert: false,
    };
  },
  computed: {
    ...mapState({
      host: state => state.host,
    }),
    isAuthorised() {
      return this.$store.getters.isAuthorised;
    },
  },
  methods: {
    ...mapActions([
      'alertMsg', // -> this.alertMsg()
    ]),
    addItem(payload) {
      this.showAlert = false;
      const id = 'modal-add-faq';
      const path = this.host + 'add_faq';
      axios.post(path, payload, { headers: { 'Authorization': `Bearer ${localStorage.token}`, 'Content-Type': 'multipart/form-data' } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.$bvModal.hide(id);
            this.$emit('faqs');
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      let payload = new FormData();
      payload.append('answer', this.addForm.answer);
      payload.append('question', this.addForm.question);
      payload.append('tags', this.addForm.tags);
      this.addItem(payload);
      this.initForm();
    },
    onReset(evt) {
      evt.preventDefault();
      this.$bvModal.hide('modal-add-faq');
      this.initForm();
    },
    initForm() {
      this.addForm.answer = '';
      this.addForm.question = '';
      this.addForm.tags = '';
    },
  },
  created() {
  },
};
</script>

<style scoped>

</style>
